import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { ListItem, Autocomplete, TextField } from '@mui/material';
import WidePopper from '../../util/WidePopper';
import { unique } from '../../../utils/collections';

const EnumSelector = ({
  entities,
  onChange,
  onBlur,

  name,
  enums,
  extractEnumId,
  enumId,
  enumLabel,
  renderBadge,
  sortFn,
}) => {
  const singleEnum = useMemo(() => {
    const observedEnumIds = unique(entities.map(extractEnumId));
    return (observedEnumIds.length === 1 && enums[observedEnumIds[0]]) || null;
  }, [entities, extractEnumId, enums]);
  const [selected, setSelected] = useState(singleEnum);
  const [prevEnums, setPrevEnums] = useState(enums);
  if (enums !== prevEnums) {
    setPrevEnums(enums);
    setSelected(singleEnum);
  }

  if (entities.length === 0) return null;

  const options = Object.values(enums);
  if (sortFn) options.sort(sortFn);
  return (
    <Autocomplete
      id={name}
      PopperComponent={WidePopper}
      options={options}
      getOptionKey={enumId}
      getOptionLabel={enumLabel}
      isOptionEqualToValue={(option, v) => enumId(option) === enumId(v)}
      value={selected}
      onChange={(event, value) => {
        setSelected(value);
        if (onChange) onChange(value);
      }}
      onBlur={onBlur}
      // eslint-disable-next-line react/jsx-props-no-spreading
      renderInput={(params) => <TextField label={`Select ${name}`} {...params} />}
      fullWidth
      selectOnFocus
      disableClearable
      renderValue={(entity) => (
        <>
          {enumLabel(entity)} {renderBadge(entity)}
        </>
      )}
      renderOption={(props, entity) => {
        const { key, ...p } = props;
        return (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem key={enumId(entity)} {...p}>
            {enumLabel(entity)} {renderBadge(entity)}
          </ListItem>
        );
      }}
    />
  );
};

export default connect()(EnumSelector);
